import { get } from "../base.schmaltz.model";
import { deserialize } from "../base.serializer";

export const getProjectFinder = async (id: string | number) => {
  const path = `project-finders/${id}`;
  try {
    const res = await get(path);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
